import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { HubsLogbook } from 'Models';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Properties, Row } from '@cae/component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function useHublogbookTableProperties(onClickEditRow: (rowData: HubsLogbook) => void) {//disable={isEditable?isEditable:false}
    const tableProperties: Properties[] = [
        {
            key: "actions",
            title: "",
            render: (_cellValue: any, rowData: Row) => (
                <Tooltip placement="right" arrow title={`Edit Request ${rowData.id}`}>
                    <IconButton disabled={rowData.isNotEditable === "true"} onClick={() => onClickEditRow(rowData as HubsLogbook)}>
                        <FontAwesomeIcon size="xs" icon={faPencilAlt} />
                    </IconButton>
                </Tooltip>
            )
        },
        {
            key: "id",
            title: "ID",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "criticity",
            title: "Priority",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "partNumber",
            title: "Part Number",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "contract",
            title: "Contract",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "quantity",
            title: "Qty",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "itemCost",
            title: "Item Cost",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "issueType",
            title: "Issue Type",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "category",
            title: "Category",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "originator",
            title: "Originator",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "createdDate",
            title: "Created Date",
            isSortable: true,
            isSearchable: true,
            render: (createdDate: Date) => <Tooltip title={moment(createdDate).fromNow()}><Box>{moment(createdDate).format("yyyy-MM-DD HH:mm")}</Box></Tooltip>
        },
        {
            key: "status",
            title: "Status",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "description",
            title: "Comment",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "comments",
            title: "Hubs Comments",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "actionee",
            title: "Actionee",
            isSortable: true,
            isSearchable: true
        },
        {
            key: "timeStamp",
            title: "Updated Date",
            isSortable: true,
            isSearchable: true,
            render: (timeStamp: Date) => <Tooltip title={moment(timeStamp).fromNow()}><Box>{moment(timeStamp).format("yyyy-MM-DD HH:mm")}</Box></Tooltip>
        },
        {
            key: "ackDate",
            title: "Date In Process",
            isSortable: true,
            isSearchable: true,
            render: (ackDate?: Date) => ackDate ? <Tooltip title={moment(ackDate).fromNow()}><Box>{moment(ackDate).format("yyyy-MM-DD HH:mm")}</Box></Tooltip> : null
        },
        {
            key: "completedDate",
            title: "Completed Date",
            isSortable: true,
            isSearchable: true,
            render: (completedDate?: Date) => completedDate ? <Tooltip title={moment(completedDate).fromNow()}><Box>{moment(completedDate).format("yyyy-MM-DD HH:mm")}</Box></Tooltip> : null
        }
    ];

    return tableProperties;
}